import { gql } from 'graphql-request';

export const UserSettingsFragment = gql`
  fragment UserSettingsFragment on UserSettingsObject {
    marketing
    terms
    use_mfa
  }
`;

export const UpdatesFragment = gql`
  fragment UpdatesFragment on Updates {
    description {
      en
      heb
    }
    reportDate
    progress
    status
    title {
      en
      heb
    }
    id
    displayTimeline
  }
`;

export const AudienceFragment = gql`
  fragment AudienceFragment on ProspectObject {
    email
    role
    firstName
    lastName
    language
  }
`;

export const LocationFragment = gql`
  fragment LocationFragment on ProjectLocationObject {
    address
    latitude
    longitude
  }
`;

export const EntityPropertiesFragment = gql`
  fragment EntityPropertiesFragment on ProjectPropertyObject {
    key
    series1Legend {
      en
      heb
    }
    series2Legend {
      en
      heb
    }
    value {
      date
      value
      projected
      title
      annotation
    }
  }
`;

export const TaxInfoFragment = gql`
  fragment TaxInfoFragment on TaxInfo {
    id
    address
    __typename
    endDate
    notes
    SSN
    startDate
    status
    TIN
  }
`;

export const UserPreferenceFragment = gql`
  fragment UserPreferenceFragment on UserPreference {
    id
    startDate
    endDate
    __typename

    investmentAmount
    currency
    investmentStructure
    investmentType
    isSuggestedByOperator
    riskReward
    strategyType
    userLegalEntityId
    customAnswers {
      questionID
      __typename
      question {
        question
      }
      selectedAnswers
    }
  }
`;

export const AccreditationInfoFragment = gql`
  fragment AccreditationInfoFragment on AccreditationInfo {
    id
    __typename
    endDate
    accreditationType
    startDate
    status
    country
    expirationDate
  }
`;

export const BankAccountFragment = gql`
  fragment BankAccountFragment on BankAccount {
    id
    accountName
    isActive
    notes
    startDate
    status
    __typename
    accountNumber
    approvedBankAccountId
    bankName
    currencies
    IBAN
    swift
    routingNumber
    benificiaryAddress
    branchAddress
    branchNumber
    endDate
  }
`;

export const UserLegalEntityFragment = gql`
  fragment UserLegalEntityFragment on UserLegalEntity {
    id
    __typename
    endDate
    startDate
    name
    uniqueId
    viewerIDs
    investorIDs
    operatorId
  }
`;

/**
 * Holds the class fragment from the project's investment section
 */
export const InvestmentClassFragment = gql`
  fragment InvestmentClassFragment on OperatorProject {
    investmentClasses {
      name
      type
      distributionPeriod
      percentage
      allocationAmount
      currency
      endDate
      extensionOptionDate
      isCompounding
    }
  }
`;

/**
 * Holds the class fragment from the project's investment section
 */
export const InvestmentClassFragmentFund = gql`
  fragment InvestmentClassFragmentFund on Fund {
    investmentClasses {
      name
      type
      distributionPeriod
      percentage
      allocationAmount
      currency
      endDate
      extensionOptionDate
      isCompounding
    }
  }
`;

export const InvestmentFragment = gql`
  fragment InvestmentFragment on Investment {
    distributions {
      investmentClassType
      date
      payDueDate
      amount
      currency
      currencyRate
      override
      expenses
      notes
      paymentComponent
      distributionPeriod
    }
    contributions {
      date
      closingDate
      contribution
      commitment
      capitalCall
      currency
      currencyRate
      percentage
      override
      investmentClassName
      notes
    }

    amount
    commitment
    date
    description {
      en
      heb
    }
    email
    sequenceId
    manualHoldings {
      date
      value
    }
    holdings {
      date
      value
    }
    id
    investedBy
    operatorId
    percentage
    period
    exitDate
    isContribution
    customizedStatistics {
      key
      value
    }
    ref {
      key
      value
    }
    type
    version
  }
`;

export const LayoutFragment = gql`
  fragment LayoutFragment on LayoutDataObject {
    key
    value
  }
`;
